import { getUpdateSchedulesFunction } from 'components/Templates/product/default/ProductEditDefaultTemplate'
import { Dispatch, SetStateAction, useCallback } from 'react'
import { StockUnionType } from 'types/stock'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useUnselectDefaultAllDaysOfWeek = (
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
) => {
  return useCallback(
    (index: number, type: StockUnionType | '') => {
      const setState = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!setState) return
      setState((prevState) => {
        prevState[index].days_of_week = []
        return [...prevState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useUnselectDefaultAllDaysOfWeek
